/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import * as constantMessageData from '../../../../../../SharedModules/Errors/constantMessageData';

import {
  dispatchErrorMessages,
  dispatchNMAccountDetails,
} from '../../../store/actions';
import { autoFormateDate } from '../../../../../../SharedModules/utilities/utilities';
import { checkQuarterValidation } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';

export default (props) => {
  const dispatch = useDispatch();
  const { colId } = props.column;
  const { disabled, value, data, setDisabledSaveCancelBtn } = props;
  const nmAccountNumberGridList = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmAccountNumber
  );
  const maxActivityDt = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.maxActivityDt
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );
  let rowIndex = 0;
  if (nmAccountNumberGridList && nmAccountNumberGridList.length > 0) {
    rowIndex = nmAccountNumberGridList.findIndex((x) => {
      return x.id === props.data?.id;
    });
  }

  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  // handing on change date event
  const handleOnChangeDateFields = (e, name) => {
    const newObj = [...nmAccountNumberGridList];
    setDisabledSaveCancelBtn(false);
    let localErr = errorMessages || [];
    props.node.setDataValue(colId, e.target.value);
    newObj[rowIndex][name] = e.target.value;
    if (colId === 'nmAccountIdVO.startQtr') {
      newObj[rowIndex].startQtrErr = false;
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.START_QTR_UC}#${props.rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.QUARTER_FORMAT_ERROR} in row #${
              props.rowIndex + 1
            }`
          )
        );
      });
    }
    if (colId === 'nmAccountIdVO.fileType') {
      newObj[rowIndex].fileTypeErr = false;
      localErr = localErr?.filter((item) => {
        return !item.includes(
          `${constantMessageData.FILE_TYPE_REQ}in row #${props.rowIndex + 1}`
        );
      });
    }
    if (colId === 'nmAccountIdVO.accountNumber') {
      newObj[rowIndex].accountNumberErr = false;
      localErr = localErr?.filter((item) => {
        return !item.includes(
          `${constantMessageData.ACCOUNT_NUMBER_REQ}in row #${
            props.rowIndex + 1
          }`
        );
      });
    }
    setErrorMessages([...new Set(localErr)]);
    dispatch(dispatchNMAccountDetails(newObj));
  };

  // call on Blur event filed level
  const handleOnBlurDate = (e) => {
    const newObj = [...nmAccountNumberGridList];
    setDisabledSaveCancelBtn(false);
    const localErr = errorMessages || [];
    let inputVal = e.target?.value;
    if (colId === 'nmAccountIdVO.startQtr') {
      inputVal = autoFormateDate(inputVal?.toUpperCase());
      newObj[rowIndex][colId] = inputVal;

      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push(
          `${constantMessageData.START_QTR_UC}#${
            props.rowIndex + 1
          } of NM Account Number tab.`
        );
      }
      if (inputVal && !checkQuarterValidation(inputVal)) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push(
          `${constantMessageData.QUARTER_FORMAT_ERROR} in row #${
            props.rowIndex + 1
          }.`
        );
      }
    } else if (colId === 'nmAccountIdVO.fileType') {
      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].fileTypeErr = true;
        localErr.push(
          `${constantMessageData.FILE_TYPE_REQ}in row #${props.rowIndex + 1}.`
        );
      }
    } else if (colId === 'nmAccountIdVO.accountNumber') {
      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].accountNumberErr = true;
        localErr.push(
          `${constantMessageData.ACCOUNT_NUMBER_REQ}in row #${
            props.rowIndex + 1
          }.`
        );
      }
    }
    newObj[rowIndex][colId] = inputVal;
    newObj[rowIndex].updateRecord = !data?.newRecord;
    props.node.setDataValue(colId, inputVal);
    setErrorMessages([...new Set(localErr)]);
    dispatch(dispatchNMAccountDetails(newObj));
  };

  const fromQtrToDT = (val) => {
    const splitQtr = val?.split('Q');
    return splitQtr[0] == '1'
      ? `01/01/${splitQtr[1]}`
      : splitQtr[0] == '2'
      ? `04/01/${splitQtr[1]}`
      : splitQtr[0] == '3'
      ? `07/01/${splitQtr[1]}`
      : splitQtr[0] == '4'
      ? `10/01/${splitQtr[1]}`
      : '';
  };
  if (colId === 'nmAccountIdVO.startQtr') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          fullWidth
          placeholder=""
          InputLabelProps={{ shrink: true }}
          className={
            nmAccountNumberGridList &&
            nmAccountNumberGridList[rowIndex] &&
            nmAccountNumberGridList[rowIndex].startQtrErr !== undefined &&
            nmAccountNumberGridList[rowIndex].startQtrErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          style={{ maxWidth: '400px' }}
          disabled={
            disabled ||
            (colId === 'nmAccountIdVO.startQtr' &&
              maxActivityDt &&
              value &&
              new Date(moment(new Date(maxActivityDt)).format('MM/DD/yyyy')) >=
                new Date(fromQtrToDT(value)) &&
              new Date(
                moment(new Date(data.lastUpdateDt)).format('MM/DD/yyyy')
              ) >= new Date(moment(new Date()).format('MM/DD/yyyy')))
          }
          inputProps={{ maxLength: 6 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
  if (colId === 'nmAccountIdVO.fileType') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          disabled={disabled}
          fullWidth
          placeholder=""
          className={
            nmAccountNumberGridList &&
            nmAccountNumberGridList[rowIndex] &&
            nmAccountNumberGridList[rowIndex].fileTypeErr !== undefined &&
            nmAccountNumberGridList[rowIndex].fileTypeErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          InputLabelProps={{ shrink: true }}
          style={{ maxWidth: '400px' }}
          inputProps={{ maxLength: 50 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
  if (colId === 'nmAccountIdVO.accountNumber') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          disabled={disabled}
          fullWidth
          placeholder=""
          className={
            nmAccountNumberGridList &&
            nmAccountNumberGridList[rowIndex] &&
            nmAccountNumberGridList[rowIndex].accountNumberErr !== undefined &&
            nmAccountNumberGridList[rowIndex].accountNumberErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          InputLabelProps={{ shrink: true }}
          style={{ maxWidth: '400px' }}
          inputProps={{ maxLength: 50 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
};
